import config from "../config";
import request from "superagent";
import qs from "qs";
import { history } from "../index";

export const GET_PUBLICATION_SHARE_DATA = "GET_PUBLICATION_SHARE_DATA";
export const GET_PUBLICATION_FORM = "GET_PUBLICATION_FORM";
export const FORM_AUTH = "FORM_AUTH";

export const getPublicationShareData = (shareId, params) => {
	let queryString = qs.stringify(params, {
		encode: true,
		addQueryPrefix: true
	});
	return {
		type: GET_PUBLICATION_SHARE_DATA,
		payload: new Promise((resolve, reject) => {
			request
				.get(config.SHARE_API_BASE + `/${shareId}${queryString}`)
				.end((err, res) => {
					if (err || !res?.ok) {
						if (res?.status === 401) {
							history.replace(`/forms/${shareId}/auth/${queryString}`);
						}
						reject(err);
					} else {
						resolve(res);
					}
				});
		})
	};
};

export const formAuth = (shareId, params, data) => {
	let queryString = qs.stringify(params, {
		encode: true,
		addQueryPrefix: true
	});
	return {
		type: FORM_AUTH,
		payload: request
			.post(config.SHARE_API_BASE + `/${shareId}${queryString}`)
			.set("Content-Type", "application/x-www-form-urlencoded")
			.send(data)
	};
};

export const getPublicationForm = formId => ({
	type: GET_PUBLICATION_FORM,
	payload: request.get(config.API_BASE + `/forms/${formId}`)
});
